<template>
  <div id="ds-widget"></div>
</template>

<script>
export default {
  name: 'WatchLive'
};
</script>